import { sortBy } from "lodash-es";

export function getCategoryDropPosition(event, allowInside) {
  const bounds = event.currentTarget.getBoundingClientRect();
  const offset = event.clientY - bounds.top;
  const content = event.currentTarget.querySelector(
    "[data-category-content]"
  )?.firstElementChild;
  const contentBounds = content?.getBoundingClientRect();
  if (
    allowInside &&
    contentBounds?.width > 0 &&
    offset >= bounds.height * 0.4 &&
    offset <= bounds.height * 0.6 &&
    event.clientX >= contentBounds.left &&
    event.clientX <= contentBounds.right
  ) {
    return "inside";
  }
  return offset < bounds.height / 2 ? "above" : "below";
}

export function getCategoryMove(
  categories,
  sourceId,
  targetId,
  position,
  rowNumber,
  emptyRowParentId = null
) {
  const byId = new Map(categories.map((category) => [category.id, category]));
  const source = byId.get(sourceId);
  const target = byId.get(targetId);
  if (!source?.isPublished || sourceId === targetId) return null;
  if (targetId != null && !target?.isPublished) return null;
  if (position === "inside" && !target) return null;

  const parentCategoryID =
    position === "inside"
      ? target.id
      : target
      ? target.parentCategoryID ?? null
      : emptyRowParentId;
  if ((source.parentCategoryID == null) !== (parentCategoryID == null))
    return null;
  if (parentCategoryID != null && !byId.has(parentCategoryID)) return null;

  const visited = new Set();
  let ancestorId = parentCategoryID;
  while (ancestorId != null) {
    if (ancestorId === sourceId || visited.has(ancestorId)) return null;
    visited.add(ancestorId);
    ancestorId = byId.get(ancestorId)?.parentCategoryID ?? null;
  }

  return {
    source,
    parentCategoryID,
    rowNumber: Number(
      position === "inside"
        ? source.rowNumber || 1
        : rowNumber ?? target?.rowNumber ?? source.rowNumber ?? 1
    ),
    targetId: position === "inside" ? null : targetId,
    position,
  };
}

export function applyCategoryMove(categories, move, sortRootByRow = true) {
  const positions = new Map();
  const parentIds = new Set([
    move.source.parentCategoryID ?? null,
    move.parentCategoryID,
  ]);
  for (const parentId of parentIds) {
    let siblings = sortBy(
      categories.filter(
        (category) =>
          category.isPublished &&
          category.id !== move.source.id &&
          (category.parentCategoryID ?? null) === parentId
      ),
      ...(parentId == null && !sortRootByRow
        ? ["stepNumber"]
        : ["rowNumber", "stepNumber"])
    );
    if (parentId === move.parentCategoryID) {
      const index =
        move.targetId == null
          ? siblings.length
          : siblings.findIndex((category) => category.id === move.targetId) +
            (move.position === "above" ? 0 : 1);
      siblings.splice(index, 0, {
        ...move.source,
        parentCategoryID: move.parentCategoryID,
        rowNumber: move.rowNumber,
      });
      if (parentId != null || sortRootByRow)
        siblings = sortBy(siblings, "rowNumber");
    }
    siblings.forEach((category, index) => {
      positions.set(category.id, { ...category, stepNumber: index + 1 });
    });
  }
  return categories.map((category) => positions.get(category.id) || category);
}
